import { useEffect, useState } from "react";

const getRemainingMs = () => {
    const chiNow = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Chicago" }));
    const target = new Date(chiNow);
    let add = (2 - chiNow.getDay() + 7) % 7;
    if (add === 0 && chiNow.getHours() >= 19) add = 7;
    target.setDate(chiNow.getDate() + add);
    target.setHours(19, 0, 0, 0);
    return Math.max(0, target.getTime() - chiNow.getTime());
};

export const Countdown = ({ compact = false }) => {
    const [ms, setMs] = useState(getRemainingMs);

    useEffect(() => {
        const t = setInterval(() => setMs(getRemainingMs()), 1000);
        return () => clearInterval(t);
    }, []);

    const units = [
        ["Days", Math.floor(ms / 86400000)],
        ["Hrs", Math.floor((ms % 86400000) / 3600000)],
        ["Min", Math.floor((ms % 3600000) / 60000)],
        ["Sec", Math.floor((ms % 60000) / 1000)],
    ];

    if (compact) {
        return (
            <div data-testid="webinar-countdown-compact" className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 font-mono text-gold text-sm tracking-[0.15em]">
                {units.map(([label, v]) => (
                    <span key={label}>
                        {String(v).padStart(2, "0")}
                        <span className="text-zinc-500 text-[10px] ml-1 uppercase">{label}</span>
                    </span>
                ))}
            </div>
        );
    }

    return (
        <div data-testid="webinar-countdown" className="mt-8">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-3">Next live webinar in</p>
            <div className="flex gap-2 sm:gap-4">
                {units.map(([label, v]) => (
                    <div key={label} className="gold-border-beam bg-white/5 px-3 sm:px-5 py-3 text-center min-w-[62px] sm:min-w-[76px]">
                        <span className="block font-serif text-2xl sm:text-3xl text-white">{String(v).padStart(2, "0")}</span>
                        <span className="block font-mono text-[9px] tracking-[0.25em] uppercase text-gold mt-1">{label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
